/**
 * Shared column sizes for ad-history creative and weather tables.
 * Every table fills the history cell. ID, Weight, and the weather field columns are fixed;
 * Name has no width, so it takes whatever is left of the row.
 */

/** ID column on every creative history table. */
export const CREATIVE_HISTORY_ID_COLUMN_STYLE = { width: 80 };
/** Weight column, on the right of the row after Name. Fits 100.00%. */
export const CREATIVE_HISTORY_WEIGHT_COLUMN_STYLE = { width: 88 };

/** Non-default weather rule field columns. */
export const WEATHER_HISTORY_CONDITION_COLUMN_STYLE = { width: 104 };
export const WEATHER_HISTORY_QUALIFIER_COLUMN_STYLE = { width: 104 };
export const WEATHER_HISTORY_VALUE_COLUMN_STYLE = { width: 72 };
export const WEATHER_HISTORY_TIMEFRAME_COLUMN_STYLE = { width: 128 };

/** 100% with fixed layout: fixed columns keep their width and the Name column fills the rest. */
export const CREATIVE_HISTORY_TABLE_STYLE = {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    width: '100%',
};

/**
 * History cell. The parent history cell sets wordBreak break-all,
 * so words such as Qualifier and Next 36 hours need normal/nowrap here.
 */
export const CREATIVE_HISTORY_CELL_STYLE = {
    verticalAlign: 'top',
    paddingRight: 24,
    whiteSpace: 'nowrap',
    wordBreak: 'normal',
};

/**
 * Name cell, and the weather rule field cells. Same as CREATIVE_HISTORY_CELL_STYLE except the
 * text may wrap inside its column. overflowWrap anywhere breaks names with no spaces;
 * wordBreak normal keeps names with spaces wrapping at word boundaries.
 * Names that fit stay on one line.
 */
export const CREATIVE_HISTORY_NAME_CELL_STYLE = {
    ...CREATIVE_HISTORY_CELL_STYLE,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
};
